export default __webpack_public_path__ + "static/media/moedas_k.1cd30b07.png";